import { comments } from '@/mocks/home';

export default function Comments() {
  return (
    <section id="comments" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          读者热评
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">来看看大家都在聊哪些好看的漫画</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {comments.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-sm font-heading text-primary-600">{item.avatar}</span>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-800 truncate">{item.user}</p>
                  <p className="text-xs text-foreground-500 truncate">在 {item.comic} 下评论</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{item.time}</span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-heart-line text-accent-500"></i>
                  {item.likes.toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}